import { all } from "redux-saga/effects";
import {
  watchFetchAllOrganizations,
  watchLoadClassAmount,
  watchLoadCourseAmount,
  watchLoadExportedSCORMPackagesAmount,
  watchLoadGroupsAmount,
  watchLoadUsersAmount,
  watchMount,
  watchSelectOrganization,
  watchUnmount,
  watchUpdateCoursesAmount,
} from "./watchers";

export function* selectOrganizationSagas() {
  yield all([
    watchFetchAllOrganizations(),
    watchLoadClassAmount(),
    watchLoadCourseAmount(),
    watchLoadExportedSCORMPackagesAmount(),
    watchSelectOrganization(),
    watchUpdateCoursesAmount(),
    watchLoadGroupsAmount(),
    watchLoadUsersAmount(),
    watchMount(),
    watchUnmount(),
  ]);
}
